<template>
  <div class="css-product-details">
    <gw-menu v-if="loadFlag" :staticList="staticList"></gw-menu>
    <div v-if="loadFlag" class="product-main">
      <design-page-display :designerInfo="designerInfo" ></design-page-display>  
      <page-bottom></page-bottom>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { appConfig } from '@/config.js';
export default {
  name: "ProductDetails",
  data() {
    return {
      loadFlag: false,
      staticList: [],
      producId: this.$route.query.id,
      designerInfo: { content: { components: [] } },
      v: ""
    }
  },
  methods: {
    getSiteInfo() {
      const { pathname: site } = location
      const ps = (site.split('/') || []).reduce((p, c) => {
        if (c && c != '#') {
          p.push(c.replaceAll('/', ''))
        }
        return p
      }, [])

      return ps
    },
    loadCustomVueComp() {
      const ps = this.getSiteInfo()
      const siteName = ps[0]
      if (!window.customCompList) {
        window.customCompList = []
      }
      this.$request.request({ url: `${siteName}/componentList.json?v=${this.v}` }).then(res => {
        let newCompList = []
        res.forEach(v => {
          let targetComp = window.customCompList.find(u => v.infoId == u.infoId)
          if (!targetComp) {
            newCompList.push(v)
          }
        })
        if (newCompList.length > 0) {
          LowcodeResolver.installCusComps(newCompList, Vue)
        }
        this.loadFlag = true;
        this.loadPage(siteName)
        this.getDetalis()
      })
    },
    async loadPage(siteName) {
      let pageData = await this.$request.request({ url: `${siteName}/index.json?v=${this.v}` })
      for (const key in pageData) {
        if(key.startsWith('gw-menu')) {
          this.staticList = pageData[key] ? pageData[key].list : []
        }
      }
    },
    getDetalis(){
      let that = this;
      this.$request.request({ url: `${appConfig.staticdataUrl}/${this.producId}/${this.producId}.json?v=${this.v}` }).then(res => {
        if (res && res.topicName) {
          document.title = res.topicName + '-中国软件';
        }
        if (!res.content) {
          res.content = { components: [] };
        } else {
          res.content = JSON.parse(res.content);
        }
        that.designerInfo = res
      })
    },
    async init() {
      this.producId = this.$route.query.id;
      const ps = this.getSiteInfo()
      const siteName = ps[0]
      try {
        const vConfig = await this.$request.request({ url: `/${siteName}/version.json?t=${Date.now()}` })
        this.v = vConfig && vConfig.version || ""
      } catch (error) {}
      this.loadCustomVueComp()
    },
  },
  created(){
    this.init()
  }
};
</script>
<style lang="scss" >
.css-product-details {
  width: 100%;
  height: 100%;
  overflow: auto;
  scroll-behavior: smooth;
}
</style>